// @ts-nocheck
import * as Types from '../../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type ApplyConfigurationCard_CheckoutConfigFragment = { __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], mhExteriorOptionNames: Array<string>, mhInteriorOptionNames: Array<string>, aduExteriorOptionNames: Array<string>, aduInteriorOptionNames: Array<string>, readyPlan?:
    | { __typename?: 'ReadyPlan', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'PlanPackage', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'DesignPackage', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'ProductOffering', id: string, name: string, code?: string | null | undefined }
   | null | undefined, productOffering?: { __typename?: 'ProductOffering', id: string, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, aduProductOffering?: { __typename?: 'ProductOffering', id: string, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } | null | undefined, aduAggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } | null | undefined };

export type ApplyConfigurationCard_ProjectReadyPlanConfigFragment = { __typename?: 'ProjectReadyPlanConfig', id: string, name?: string | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], exteriorOptionNames: Array<string>, interiorOptionNames: Array<string>, readyPlan?:
    | { __typename?: 'ReadyPlan', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'PlanPackage', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'DesignPackage', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'ProductOffering', id: string, name: string, code?: string | null | undefined }
   | null | undefined, productOffering?: { __typename?: 'ProductOffering', id: string, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } | null | undefined };

export type ApplyConfigurationCard_AggregateVersionFragment = { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string };

export type ApplyConfigurationCard_ProductOfferingFragment = { __typename?: 'ProductOffering', id: string, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined };

export const ApplyConfigurationCard_ProductOfferingFragmentDoc = gql`
    fragment ApplyConfigurationCard_ProductOffering on ProductOffering {
  id
  coverAsset {
    id
    previewUrl(resizing: {width: 321, region: FULL})
  }
}
    `;
export const ApplyConfigurationCard_AggregateVersionFragmentDoc = gql`
    fragment ApplyConfigurationCard_AggregateVersion on ReadyPlanAggregateVersion {
  id
  displayVersion
}
    `;
export const ApplyConfigurationCard_CheckoutConfigFragmentDoc = gql`
    fragment ApplyConfigurationCard_CheckoutConfig on CheckoutConfig {
  id
  name
  updatedAt
  readyPlan {
    id
    name
    code
  }
  mhExteriorOptionNames
  mhInteriorOptionNames
  aduExteriorOptionNames
  aduInteriorOptionNames
  productOffering {
    ...ApplyConfigurationCard_ProductOffering
  }
  aduProductOffering {
    ...ApplyConfigurationCard_ProductOffering
  }
  aggregateVersion {
    ...ApplyConfigurationCard_AggregateVersion
  }
  aduAggregateVersion {
    ...ApplyConfigurationCard_AggregateVersion
  }
}
    ${ApplyConfigurationCard_ProductOfferingFragmentDoc}
${ApplyConfigurationCard_AggregateVersionFragmentDoc}`;
export const ApplyConfigurationCard_ProjectReadyPlanConfigFragmentDoc = gql`
    fragment ApplyConfigurationCard_ProjectReadyPlanConfig on ProjectReadyPlanConfig {
  id
  name
  updatedAt
  readyPlan {
    id
    name
    code
  }
  exteriorOptionNames
  interiorOptionNames
  productOffering {
    ...ApplyConfigurationCard_ProductOffering
  }
  aggregateVersion {
    ...ApplyConfigurationCard_AggregateVersion
  }
}
    ${ApplyConfigurationCard_ProductOfferingFragmentDoc}
${ApplyConfigurationCard_AggregateVersionFragmentDoc}`;